import { createContext } from 'react';

export const TaggingEvent = {
  ClickFavoriteIconButton: 'click:favorite-icon-button',
  GalleryNavigate: 'navigate:gallery',
  ClickCarTile: 'click:car-tile',
  ClickMonthlyPaymentInfoIcon: 'click:monthly-payment-info-icon',
} as const;

export type TaggingData = {
  event: (typeof TaggingEvent)[keyof typeof TaggingEvent];
  data?: Record<string, unknown>;
};

export type TaggingContextData = {
  dispatchTaggingEvent: (data: TaggingData) => void;
};

export const TaggingContext = createContext<TaggingContextData>({
  dispatchTaggingEvent: () => {},
});
